<script setup lang="ts">
import { defineProps } from "vue";

const { title, paddingLeft } = defineProps<{
	title?: string;
	subtitle?: string;
	paddingLeft?: number;
}>();
</script>

<template>
	<div class="settings-row">
		<div class="line" :class="`pl-${paddingLeft}`">
			<h6 class="text-h6" v-if="title">{{ title }}</h6>
			<div class="py-2 w-100">
				<slot />
			</div>
		</div>
	</div>
</template>

<style scoped>
.settings-row {
	position: relative;
	padding-left: 24px; /* Offset to leave space for the line */
}

.line {
	position: relative;
}

.line::before {
	content: "";
	position: absolute;
	left: -16px; /* Adjust as needed to center the line */
	top: 0;
	bottom: -16px;
	width: 2px;
	background-color: rgb(var(--color-secondary));
}

/* Adjustments to spacing */
.text-h6,
.text-subtitle-1 {
	margin: 0;
}
</style>
